var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
__name(_toConsumableArray, "_toConsumableArray");
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableSpread, "_nonIterableSpread");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
__name(_iterableToArray, "_iterableToArray");
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
__name(_arrayWithoutHoles, "_arrayWithoutHoles");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import classNames from "classnames";
import { Carousel, Row, Col } from "@riseart/antd-provider";
import { EmbeddedMedia, MediaThumbnail, MediaQuery } from "@riseart/common";
import { imgCarouselCls, imgCarouselVerticalCls, imgCarouselMainCls, imgCarouselMainItemCls, imgCarouselMainWrapperCls, imgCarouselClickableItemCls, imgCarouselSingleImageCls, imgCarouselThumbnailsListCls, imgCarouselThumbnailCls, imgCarouselThumbnailActiveCls, imgCarouselPortraitCls, imgCarouselLandscapeCls, imgCarouselMediaItemCls, imgCarouselThumbnailMediaCls, imgCarouselThumbnailMediaSlideCls, imgCarouselThumbnailSliderCenterCls, screenMdMax, screenSmMax } from "./Carousel.less";
var DEFAULT_INDEX = 0;
var ORIENTATION_CLASSNAMES = {
  portrait: imgCarouselPortraitCls,
  landscape: imgCarouselLandscapeCls
};
var ArtCarousel = /* @__PURE__ */ function(_Component) {
  function ArtCarousel2(props) {
    var _this;
    _classCallCheck(this, ArtCarousel2);
    _this = _callSuper(this, ArtCarousel2, [props]);
    _defineProperty(_this, "handleClick", function(idx) {
      return function(e) {
        typeof _this.props.onClickItem === "function" && _this.props.onClickItem(idx, e);
      };
    });
    _this.carousel = /* @__PURE__ */ React.createRef();
    _this.carouselThumbs = /* @__PURE__ */ React.createRef();
    _this.state = {
      selectedSlide: _this.props.initialSlide || DEFAULT_INDEX
    };
    _this.bindMethods();
    return _this;
  }
  __name(ArtCarousel2, "ArtCarousel");
  _inherits(ArtCarousel2, _Component);
  return _createClass(ArtCarousel2, [{
    key: "componentDidMount",
    value: (
      /**
       * componentDidMount
       */
      /* @__PURE__ */ __name(function componentDidMount() {
        this.carousel.current && typeof this.carousel.current.goTo === "function" && this.carousel.current.goTo(this.state.selectedSlide, true);
        this.carouselThumbs.current && typeof this.carouselThumbs.current.goTo === "function" && this.carouselThumbs.current.goTo(this.state.selectedSlide, true);
      }, "componentDidMount")
    )
    /**
     * componentDidUpdate
     * @param {Props} prevProps
     * @param {State} prevState
     */
  }, {
    key: "componentDidUpdate",
    value: /* @__PURE__ */ __name(function componentDidUpdate(prevProps, prevState) {
      if (this.state.selectedSlide !== prevState.selectedSlide) {
        this.carousel.current.goTo(this.state.selectedSlide);
        this.carouselThumbs.current.goTo(this.state.selectedSlide);
      }
    }, "componentDidUpdate")
  }, {
    key: "handleThumbnailClick",
    value: (
      /**
       * handleThumbnailClick
       * @param {number} selectedSlide
       */
      /* @__PURE__ */ __name(function handleThumbnailClick(selectedSlide) {
        var _this2 = this;
        return function(e) {
          e.preventDefault();
          _this2.setState({
            selectedSlide
          });
        };
      }, "handleThumbnailClick")
    )
  }, {
    key: "handleSwipe",
    value: /* @__PURE__ */ __name(function handleSwipe(direction) {
      this.setState(function(_ref, _ref2) {
        var selectedSlide = _ref.selectedSlide;
        var _ref2$images = _ref2.images, images = _ref2$images === void 0 ? [] : _ref2$images;
        return direction === "left" ? {
          selectedSlide: selectedSlide < images.length - 1 ? selectedSlide + 1 : 0
        } : {
          selectedSlide: selectedSlide >= 1 ? selectedSlide - 1 : images.length - 1
        };
      });
    }, "handleSwipe")
    /**
     * bindMethods
     */
  }, {
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.handleThumbnailClick = this.handleThumbnailClick.bind(this);
      this.handleSwipe = this.handleSwipe.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }, "bindMethods")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this3 = this;
      var _this$props = this.props, _this$props$images = _this$props.images, images = _this$props$images === void 0 ? [] : _this$props$images, _this$props$media = _this$props.media, media = _this$props$media === void 0 ? [] : _this$props$media, ActionsComponent = _this$props.actions, className = _this$props.className, orientation = _this$props.orientation;
      var items = [].concat(_toConsumableArray((images || []).map(function(item) {
        return {
          type: "image",
          data: item
        };
      })), _toConsumableArray((media || []).map(function(item) {
        return {
          type: "media",
          data: _objectSpread(_objectSpread({}, item), {}, {
            thumbnail: /* @__PURE__ */ React.createElement("div", {
              className: imgCarouselThumbnailMediaCls
            }, /* @__PURE__ */ React.createElement(MediaThumbnail, {
              platform: item.mediaPlatform,
              id: item.mediaId
            }))
          })
        };
      })));
      var totalItems = items ? items.length : 0;
      var hasMultipleItems = totalItems > 1;
      var hasClickHandler = typeof this.props.onClickItem === "function";
      var isPortrait = orientation === "portrait";
      var RowComponent = hasMultipleItems ? Row : "div";
      return /* @__PURE__ */ React.createElement(RowComponent, {
        className: classNames(imgCarouselCls, orientation && ORIENTATION_CLASSNAMES[orientation], className)
      }, /* @__PURE__ */ React.createElement(Col, {
        flex: hasMultipleItems,
        className: imgCarouselMainWrapperCls
      }, hasMultipleItems ? /* @__PURE__ */ React.createElement(Carousel, {
        className: imgCarouselMainCls,
        draggable: true,
        swipe: true,
        dots: false,
        onSwipe: this.handleSwipe,
        ref: this.carousel
      }, items.map(function(_ref3, idx) {
        var type = _ref3.type, data = _ref3.data;
        if (type === "image") {
          var original = data.original;
          return /* @__PURE__ */ React.createElement("div", _extends({}, hasClickHandler ? {
            onClick: _this3.handleClick(idx)
          } : {}, {
            key: original,
            className: classNames(imgCarouselMainItemCls, _defineProperty({}, imgCarouselClickableItemCls, hasClickHandler))
          }), original);
        } else if (type === "media") {
          return /* @__PURE__ */ React.createElement("div", {
            key: "".concat(data.mediaId, "-").concat(idx),
            className: classNames(imgCarouselMainItemCls)
          }, /* @__PURE__ */ React.createElement("div", {
            className: imgCarouselMediaItemCls
          }, /* @__PURE__ */ React.createElement(EmbeddedMedia, {
            platform: data.mediaPlatform,
            id: data.mediaId
          })));
        }
        return null;
      })) : /* @__PURE__ */ React.createElement("div", _extends({
        className: classNames(imgCarouselSingleImageCls, _defineProperty({}, imgCarouselClickableItemCls, hasClickHandler))
      }, hasClickHandler ? {
        onClick: this.handleClick(0)
      } : {}), items && items[0] && items[0].type === "image" && items[0].data.original || items && items[0] && items[0].type === "media" && /* @__PURE__ */ React.createElement("div", {
        className: imgCarouselSingleImageCls
      }, /* @__PURE__ */ React.createElement(EmbeddedMedia, {
        platform: items[0].data.mediaPlatform,
        id: items[0].data.mediaId
      })))), hasMultipleItems ? /* @__PURE__ */ React.createElement(Col, {
        className: classNames(imgCarouselThumbnailsListCls, isPortrait && imgCarouselVerticalCls)
      }, /* @__PURE__ */ React.createElement(MediaQuery, {
        maxWidth: screenSmMax
      }, function(isSmallScreen) {
        return /* @__PURE__ */ React.createElement(Carousel, _extends({}, isSmallScreen && totalItems <= 5 || !isSmallScreen && totalItems <= 10 ? {
          className: imgCarouselThumbnailSliderCenterCls
        } : null, {
          draggable: true,
          arrows: true,
          dots: false,
          itemsPerSlide: 1,
          slidesToShow: isPortrait ? 1 : 10,
          infinite: false,
          vertical: isPortrait,
          ref: _this3.carouselThumbs,
          responsive: [{
            breakpoint: parseInt(screenMdMax, 10),
            settings: {
              vertical: false,
              slidesToShow: 10
            }
          }, {
            breakpoint: parseInt(screenSmMax, 10),
            settings: {
              vertical: false,
              slidesToShow: 5
            }
          }]
        }), items.map(function(_ref4, idx) {
          var type = _ref4.type, thumbnail = _ref4.data.thumbnail;
          return /* @__PURE__ */ React.createElement("button", {
            key: "".concat(type, "-").concat(idx),
            type: "button",
            onClick: _this3.handleThumbnailClick(idx),
            className: classNames(imgCarouselThumbnailCls, _defineProperty(_defineProperty({}, imgCarouselThumbnailMediaSlideCls, type === "media"), imgCarouselThumbnailActiveCls, idx === _this3.state.selectedSlide))
          }, thumbnail);
        }));
      })) : null, ActionsComponent && /* @__PURE__ */ React.createElement(ActionsComponent, {
        data: images[this.state.selectedSlide]
      }));
    }, "render")
  }]);
}(Component);
_defineProperty(ArtCarousel, "defaultProps", {
  className: null,
  initialSlide: 0,
  images: [],
  media: [],
  actions: null,
  onClickItem: null,
  orientation: "landscape"
});
export {
  ArtCarousel
};
